export default __webpack_public_path__ + "static/media/katalog.d253ca93.jpg";